<div
  class="filter-container"
  fxLayout="row wrap"
  fxLayoutGap="0.5em"
  fxLayoutAlign=" center"
  fxLayoutAlign.xs=" none"
>
  <button
    mat-stroked-button
    [matMenuTriggerFor]="menuYears"
    class="buttonWidth"
    color="{{ branches.length != 0 ? 'primary' : 'gray' }}"
  >
    <div>
      <div fxLayout="row" fxLayoutAlign="center center">
        <span>Branch</span
        ><span class="material-icons font-size-16"> arrow_drop_down </span>
      </div>
      <mat-menu #menuYears="matMenu" class="menu-event-filters">
        <span><b>Filter by</b></span>
        <hr />
        <div class="card-scroll">
          <div
            class="employee-container text_card"
            fxLayout="row"
            fxLayoutAlign="start"
            *ngFor="let branch of branchList"
          >
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="selectedBranch(branch.id)"
            >
              <span class="employee-name">{{ branch.name | titlecase }}</span>
            </mat-checkbox>
          </div>
        </div>
      </mat-menu>
    </div>
  </button>
</div>
